import React from 'react';
import { Clock, MapPin, Phone } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { workingHours, companyInfo } from '../data/mock';

export const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider mb-2 block">
            Visite-nos
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Horário e Localização
          </h2>
          <p className="text-lg text-slate-600">
            Estamos prontos para atendê-lo. Visite nossa oficina ou entre em contato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Working Hours Card */}
          <Card className="shadow-xl border-slate-200 overflow-hidden">
            <CardHeader className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                  <Clock size={24} />
                </div>
                <CardTitle className="text-2xl">Horário de Funcionamento</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="p-6">
              <div className="space-y-3">
                {workingHours.map((schedule, index) => (
                  <div 
                    key={index}
                    className={`flex justify-between items-center py-3 px-4 rounded-lg transition-colors ${
                      schedule.open 
                        ? 'bg-slate-50 hover:bg-slate-100' 
                        : 'bg-slate-100 opacity-60'
                    }`}
                  >
                    <span className="font-medium text-slate-700">
                      {schedule.day}
                    </span>
                    <span className={`font-semibold ${
                      schedule.open ? 'text-blue-600' : 'text-slate-500'
                    }`}>
                      {schedule.hours}
                    </span>
                  </div>
                ))}
              </div>

              <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <p className="text-sm text-blue-800">
                  <strong>Nota:</strong> Para garantir atendimento, recomendamos agendamento prévio
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Contact Information Card */}
          <Card className="shadow-xl border-slate-200 overflow-hidden">
            <CardHeader className="bg-gradient-to-r from-slate-800 to-slate-700 text-white">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                  <MapPin size={24} />
                </div>
                <CardTitle className="text-2xl">Informações de Contato</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="p-6">
              <div className="space-y-6">
                {/* Address */}
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800 mb-1">Endereço</h3>
                    <p className="text-slate-600">{companyInfo.address}</p>
                    <a 
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyInfo.address)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 text-sm font-medium mt-1 inline-block"
                    >
                      Ver no mapa →
                    </a>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-800 mb-1">Telefone</h3>
                    <a 
                      href={`tel:${companyInfo.phoneFormatted}`}
                      className="text-slate-600 hover:text-blue-600 transition-colors"
                    >
                      {companyInfo.phoneFormatted}
                    </a>
                  </div>
                </div>
              </div>

              {/* Map Preview */}
              <div className="mt-6 rounded-lg overflow-hidden border border-slate-200">
                <iframe
                  title="Localização LMP Pinturas"
                  src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(companyInfo.address)}`}
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
